<div *ngIf="svcResponse"
    class="campaign"
    [finderParallax]="svcResponse.parallaxData"
    [ngClass]="{
        'icon-cutout': svcResponse.iconBarData?.isIconCutOut,
        'disable-mask': svcResponse.iconBarData?.disableMask
    }"
>
    <finder-currency-converter-widget *ngIf="svcResponse.currencyConverterEnabled"></finder-currency-converter-widget>
    <div class="campaign-hero" *ngIf="svcResponse.heroData">
        <finder-campaign-countdown-clock *ngIf="svcResponse.countdownClock"
            [countdownClockData]="svcResponse.countdownClock"
            [target]="'hero'"
            class="campaign-countdown-clock"
        ></finder-campaign-countdown-clock>
        <finder-hero-story *ngIf="svcResponse.heroData"
            [heroData]="svcResponse.heroData"
        ></finder-hero-story>
    </div>
    @defer {
        <finder-flip-clock *ngIf="svcResponse.flipClock"
            (removeFlipClock)="removeFlipClockModule()"
            class="campaign-flip-clock"
            tabindex="-1"
            [data]="svcResponse.flipClock">
        </finder-flip-clock>
    }
    <div class="campaign-content" finderInterstitialTrigger [interstitialLabels]="interstitialModal">
        <section class="campaign-top-section"
            [finderBgImage]="svcResponse.headerData"
            [isMobile]="isMobile"
            bgTarget="campaign-content-top"
        >
            <finder-icon-bar *ngIf="svcResponse.iconBarData"
                [iconBarData]="svcResponse.iconBarData"
                class="finder-icon-bar"
            ></finder-icon-bar>
            <finder-overview-cta *ngIf="svcResponse.overviewCta"
                [data]="svcResponse.overviewCta"
            ></finder-overview-cta>
            <finder-overview-aag *ngIf="svcResponse.overviewAag"
                [data]="svcResponse.overviewAag"
            ></finder-overview-aag>
            <div class="campaign-top {{svcResponse.headerData?.style ?? ''}}" *ngIf="svcResponse?.headerData"
                [ngClass]="{'empty-info-bar': emptyInfoBar, 'bottom-clock': bottomClock, 'empty-header-data': !contentHeaderData}">
                <div class="print-button" *ngIf="svcResponse.printButton">
                    <finder-font-icon
                        htmlEntity="&#58127;"
                    ></finder-font-icon>
                    <finder-button anchor="true" (click)="print()"
                        [title]="svcResponse.printButton.text">
                        {{svcResponse.printButton.text}}
                    </finder-button>
                </div>
                <finder-content-header *ngIf="contentHeaderData"
                    [headerData]="svcResponse.headerData"
                    [finderCmsMargin]="svcResponse.headerData"
                ></finder-content-header>
                <finder-campaign-countdown-clock *ngIf="svcResponse.countdownClock"
                    [countdownClockData]="svcResponse.countdownClock"
                    [finderCmsMargin]="svcResponse.countdownClock"
                    [target]="'shortDescription'"
                    class="campaign-countdown-clock"
                ></finder-campaign-countdown-clock>
                <finder-info-bar *ngIf="svcResponse.infoBarData"
                    [infoBarData]="svcResponse.infoBarData"
                    class="finder-info-bar"
                ></finder-info-bar>
            </div>
            <finder-overview-refurb-msg *ngIf="svcResponse.overviewRefurb"
                [data]="svcResponse.overviewRefurb"
            ></finder-overview-refurb-msg>
        </section>
        <!-- Sticky Components MUST be at the root of the "campaign-content" element -->
        <div class="sticky-components" *ngIf="contentNavigation || svcResponse.stickyCta">
            <finder-content-navigation *ngIf="contentNavigation"
                [links]="contentNavigation.links"
                [sidePolylines]="contentNavigation.sidePolylines"
                [cta]="contentNavigation.cta"
                [logo]="contentNavigation.logo"
                [ariaCurrent]="contentNavigation.ariaCurrent"
                [blockClasses]="contentNavigation.blockClasses"
                [ariaLabel]="contentNavigation?.ariaLabel"
                [disableMobile]="contentNavigation.disableMobile"
            >
            </finder-content-navigation>
            <finder-campaign-sticky-cta *ngIf="svcResponse.stickyCta"
                [stickyCtaData]="svcResponse.stickyCta"
                [class.hasnav]="contentNavigation"
            ></finder-campaign-sticky-cta>
        </div>
        <div class="image-drawer" *ngIf="imageDrawer">
            <finder-image-drawer
                [data]="imageDrawer.data"
            ></finder-image-drawer>
        </div>
        <div *ngIf="enableHorizontalRule"
            [finderCmsMargin]="svcResponse.headerData"
            class="horizontal-line"
        ></div>
        <finder-block-layout-renderer
            [blocks]="svcResponse.blockData"
            [theme]="svcResponse.themeData"
            [disableDefaultSpacing]="svcResponse.disableDefaultSpacing"
            [ngClass]="{'no-header': !svcResponse.headerData || !enableHorizontalRule}"
        ></finder-block-layout-renderer>
        <finder-disclaimer *ngIf="svcResponse.disclaimerData"
            [disclaimer]="svcResponse.disclaimerData.text"
            [ngClass]="svcResponse.disclaimerData.blockClasses"
        ></finder-disclaimer>
    </div>
</div>
